import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { find } from 'utils/dom';

export default function () {
  const BlogPage = find("[js-page='blog'], [js-page='single-blog']");
  if (!BlogPage) return;

  const swiperContainer = document.querySelector(".mySwiperBlog");
  const postDestaque = document.querySelector(".post-destaque");
  const inputBusca = document.getElementById("conteudo");

  const toggleBtn = document.getElementById("btn-toggle-categorias");
  const dropdown = document.getElementById("lista-categorias");
  const iconeSeta = document.getElementById("icone-seta");
  const categoriaBtns = document.querySelectorAll("#categoria-filtro .categoria-btn");

  let categoriaSelecionada = "";

  const $config = {
    numeracao: document.querySelector(".swiper-numeracao-blog-ativo"),
    setNumeracao: (_n) => {
      $config.numeracao.innerText = (_n < 10) ? "0" + _n : _n;
    },
    numeracaoTotal: document.querySelector(".swiper-numeracao-blog-total"),
    setNumeracaoTotal: () => {
      let n = document.querySelectorAll(".swiper-pagination-blog .swiper-pagination-bullet").length;
      $config.numeracaoTotal.innerText = (n < 10) ? "0" + n : n;
    }
  };

  const SwiperBlog = new Swiper(swiperContainer, {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 32,
    navigation: {
      nextEl: ".swiper-button-next-blog",
      prevEl: ".swiper-button-prev-blog",
    },
    pagination: {
      el: ".swiper-pagination-blog",
      clickable: true,
    },
    breakpoints: {
      1280: { slidesPerView: 4, slidesPerGroup: 4 },
      1024: { slidesPerView: 3, slidesPerGroup: 3 },
      640: { slidesPerView: 2, slidesPerGroup: 2 },
    },
    on: {
      init: () => {
        $config.setNumeracaoTotal();
        $config.setNumeracao(1);
      },
      slideChange: () => {
        const barraAtiva = document.querySelector(".swiper-pagination-blog .swiper-pagination-bullet.swiper-pagination-bullet-active");
        if (!barraAtiva) return;
        const progress = parseInt(barraAtiva.getAttribute('aria-label').split("Go to slide ")[1]);
        $config.setNumeracao(progress);
      },
      resize: () => {
        $config.setNumeracaoTotal();
      }
    }
  });

  const slides = Array.from(document.querySelectorAll(".swiper-slide"));

  function filtrarTudo() {
    const termo = inputBusca.value.trim().toLowerCase();
    let algumVisivel = false;

    slides.forEach(slide => {
      const tituloEl = slide.querySelector('.text-pilat-headline-1');
      const texto = tituloEl ? tituloEl.textContent.toLowerCase() : "";

      const categoriasSlide = slide.getAttribute("data-categorias") || "";
      const categoriasArray = categoriasSlide.split(",").map(c => c.trim());

      const correspondeTexto = !termo || texto.includes(termo);
      const correspondeCategoria = !categoriaSelecionada || categoriasArray.includes(categoriaSelecionada);

      const mostrar = correspondeTexto && correspondeCategoria;
      slide.style.display = mostrar ? "block" : "none";

      if (mostrar) algumVisivel = true;
    });

    SwiperBlog.update();

    if (algumVisivel) {
      $config.setNumeracaoTotal();
      $config.setNumeracao(SwiperBlog.realIndex + 1);
    } else {
      $config.numeracaoTotal.innerText = "00";
      $config.numeracao.innerText = "00";
    }

    if (postDestaque) {
      const tituloDestaqueEl = postDestaque.querySelector(".text-pilat-title-2-2");
      const textoDestaque = tituloDestaqueEl ? tituloDestaqueEl.textContent.toLowerCase() : "";

      const categoriasDestaque = postDestaque.getAttribute("data-categorias") || "";
      const categoriasDestaqueArray = categoriasDestaque.split(",").map(c => c.trim());

      const correspondeTextoDestaque = !termo || textoDestaque.includes(termo);
      const correspondeCategoriaDestaque = !categoriaSelecionada || categoriasDestaqueArray.includes(categoriaSelecionada);

      postDestaque.style.display = (correspondeTextoDestaque && correspondeCategoriaDestaque) ? "flex" : "none";
    }
  }

  // Filtro de texto
  inputBusca.addEventListener("input", filtrarTudo);
  inputBusca.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      filtrarTudo();
    }
  });

  const lupaSvg = inputBusca.parentElement.querySelector("svg");
  if (lupaSvg) {
    lupaSvg.addEventListener("click", filtrarTudo);
  }

  // Filtro por categoria
  if (categoriaBtns) {
    categoriaBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        categoriaBtns.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        // Atualiza texto do botão principal
        const textoBotao = toggleBtn.querySelector("p");
        if (textoBotao) {
          textoBotao.textContent = btn.textContent.trim();
        }

        // Fecha dropdown
        dropdown.classList.add("hidden", "pointer-events-none");
        iconeSeta.classList.remove("rotate-180");

        // Atualiza categoria selecionada
        categoriaSelecionada = btn.getAttribute("data-categoria-id") || "";

        // Refaz filtro
        filtrarTudo();
      });
    });
  }

  // Toggle dropdown
  if (toggleBtn && dropdown) {
    toggleBtn.addEventListener("click", () => {
      const isHidden = dropdown.classList.contains("hidden");

      if (isHidden) {
        dropdown.classList.remove("hidden", "pointer-events-none");
        iconeSeta.classList.add("rotate-180");
      } else {
        dropdown.classList.add("hidden", "pointer-events-none");
        iconeSeta.classList.remove("rotate-180");
      }
    });

    // Fecha ao clicar fora
    document.addEventListener("click", (e) => {
      if (!dropdown.contains(e.target) && !toggleBtn.contains(e.target)) {
        dropdown.classList.add("hidden", "pointer-events-none");
        iconeSeta.classList.remove("rotate-180");
      }
    });
  }

  console.log("swiper-blog com busca + botões de categoria carregado");
}
